export default "__VITE_ASSET__9629c760__"